/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { communityCommentControllerCreate } from '../fn/community-comment/community-comment-controller-create';
import { CommunityCommentControllerCreate$Params } from '../fn/community-comment/community-comment-controller-create';
import { communityCommentControllerDelete } from '../fn/community-comment/community-comment-controller-delete';
import { CommunityCommentControllerDelete$Params } from '../fn/community-comment/community-comment-controller-delete';
import { communityCommentControllerFindByCommunityId } from '../fn/community-comment/community-comment-controller-find-by-community-id';
import { CommunityCommentControllerFindByCommunityId$Params } from '../fn/community-comment/community-comment-controller-find-by-community-id';
import { communityCommentControllerFindById } from '../fn/community-comment/community-comment-controller-find-by-id';
import { CommunityCommentControllerFindById$Params } from '../fn/community-comment/community-comment-controller-find-by-id';
import { communityCommentControllerMy } from '../fn/community-comment/community-comment-controller-my';
import { CommunityCommentControllerMy$Params } from '../fn/community-comment/community-comment-controller-my';
import { communityCommentControllerReport } from '../fn/community-comment/community-comment-controller-report';
import { CommunityCommentControllerReport$Params } from '../fn/community-comment/community-comment-controller-report';
import { communityCommentControllerSearchCursor } from '../fn/community-comment/community-comment-controller-search-cursor';
import { CommunityCommentControllerSearchCursor$Params } from '../fn/community-comment/community-comment-controller-search-cursor';
import { communityCommentControllerSearchOffset } from '../fn/community-comment/community-comment-controller-search-offset';
import { CommunityCommentControllerSearchOffset$Params } from '../fn/community-comment/community-comment-controller-search-offset';
import { communityCommentControllerToggleBlocked } from '../fn/community-comment/community-comment-controller-toggle-blocked';
import { CommunityCommentControllerToggleBlocked$Params } from '../fn/community-comment/community-comment-controller-toggle-blocked';
import { communityCommentControllerUpdate } from '../fn/community-comment/community-comment-controller-update';
import { CommunityCommentControllerUpdate$Params } from '../fn/community-comment/community-comment-controller-update';
import { CommunityCommentDto } from '../models/community-comment-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class CommunityCommentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `communityCommentControllerSearchOffset()` */
  static readonly CommunityCommentControllerSearchOffsetPath = '/api/community-comments/{id}/search/offset';

  /**
   * 커뮤니티 댓글 오프셋 기반 조회.
   *
   * 커뮤니티 댓글을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityCommentControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerSearchOffset$Response(params: CommunityCommentControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return communityCommentControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 댓글 오프셋 기반 조회.
   *
   * 커뮤니티 댓글을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityCommentControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerSearchOffset(params: CommunityCommentControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.communityCommentControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `communityCommentControllerMy()` */
  static readonly CommunityCommentControllerMyPath = '/api/community-comments/my';

  /**
   * 회원 작성 커뮤니티 댓글 조회.
   *
   * 회원이 작성한 커뮤니티 댓글을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityCommentControllerMy()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerMy$Response(params?: CommunityCommentControllerMy$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityCommentDto>>> {
    return communityCommentControllerMy(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 작성 커뮤니티 댓글 조회.
   *
   * 회원이 작성한 커뮤니티 댓글을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityCommentControllerMy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerMy(params?: CommunityCommentControllerMy$Params, context?: HttpContext): Observable<Array<CommunityCommentDto>> {
    return this.communityCommentControllerMy$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CommunityCommentDto>>): Array<CommunityCommentDto> => r.body)
    );
  }

  /** Path part for operation `communityCommentControllerFindById()` */
  static readonly CommunityCommentControllerFindByIdPath = '/api/community-comments/{id}';

  /**
   * 커뮤니티 댓글 ID 기반 조회.
   *
   * 커뮤니티 댓글을 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityCommentControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerFindById$Response(params: CommunityCommentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityCommentDto>> {
    return communityCommentControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 댓글 ID 기반 조회.
   *
   * 커뮤니티 댓글을 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityCommentControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerFindById(params: CommunityCommentControllerFindById$Params, context?: HttpContext): Observable<CommunityCommentDto> {
    return this.communityCommentControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommunityCommentDto>): CommunityCommentDto => r.body)
    );
  }

  /** Path part for operation `communityCommentControllerDelete()` */
  static readonly CommunityCommentControllerDeletePath = '/api/community-comments/{id}';

  /**
   * 커뮤니티 댓글 삭제.
   *
   * 커뮤니티 댓글을 삭제합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityCommentControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerDelete$Response(params: CommunityCommentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityCommentDto>> {
    return communityCommentControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 댓글 삭제.
   *
   * 커뮤니티 댓글을 삭제합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityCommentControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerDelete(params: CommunityCommentControllerDelete$Params, context?: HttpContext): Observable<CommunityCommentDto> {
    return this.communityCommentControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommunityCommentDto>): CommunityCommentDto => r.body)
    );
  }

  /** Path part for operation `communityCommentControllerUpdate()` */
  static readonly CommunityCommentControllerUpdatePath = '/api/community-comments/{id}';

  /**
   * 커뮤니티 댓글 수정.
   *
   * 커뮤니티 댓글을 수정합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityCommentControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityCommentControllerUpdate$Response(params: CommunityCommentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityCommentDto>> {
    return communityCommentControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 댓글 수정.
   *
   * 커뮤니티 댓글을 수정합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityCommentControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityCommentControllerUpdate(params: CommunityCommentControllerUpdate$Params, context?: HttpContext): Observable<CommunityCommentDto> {
    return this.communityCommentControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommunityCommentDto>): CommunityCommentDto => r.body)
    );
  }

  /** Path part for operation `communityCommentControllerFindByCommunityId()` */
  static readonly CommunityCommentControllerFindByCommunityIdPath = '/api/community-comments/community/{communityId}';

  /**
   * 커뮤니티 게시글 ID 기반 조회.
   *
   * 댓글을 게시글 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityCommentControllerFindByCommunityId()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerFindByCommunityId$Response(params: CommunityCommentControllerFindByCommunityId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityCommentDto>>> {
    return communityCommentControllerFindByCommunityId(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 게시글 ID 기반 조회.
   *
   * 댓글을 게시글 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityCommentControllerFindByCommunityId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerFindByCommunityId(params: CommunityCommentControllerFindByCommunityId$Params, context?: HttpContext): Observable<Array<CommunityCommentDto>> {
    return this.communityCommentControllerFindByCommunityId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CommunityCommentDto>>): Array<CommunityCommentDto> => r.body)
    );
  }

  /** Path part for operation `communityCommentControllerSearchCursor()` */
  static readonly CommunityCommentControllerSearchCursorPath = '/api/community-comments/search/cursor/community/{communityId}';

  /**
   * 커뮤니티 ID 기반 커서 조회.
   *
   * 커뮤니티 댓글을 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityCommentControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerSearchCursor$Response(params: CommunityCommentControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return communityCommentControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 ID 기반 커서 조회.
   *
   * 커뮤니티 댓글을 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityCommentControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerSearchCursor(params: CommunityCommentControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.communityCommentControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `communityCommentControllerCreate()` */
  static readonly CommunityCommentControllerCreatePath = '/api/community-comments';

  /**
   * 커뮤니티 댓글 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityCommentControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityCommentControllerCreate$Response(params: CommunityCommentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityCommentDto>> {
    return communityCommentControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 댓글 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityCommentControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityCommentControllerCreate(params: CommunityCommentControllerCreate$Params, context?: HttpContext): Observable<CommunityCommentDto> {
    return this.communityCommentControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommunityCommentDto>): CommunityCommentDto => r.body)
    );
  }

  /** Path part for operation `communityCommentControllerReport()` */
  static readonly CommunityCommentControllerReportPath = '/api/community-comments/{id}/report';

  /**
   * 커뮤니티 댓글 신고.
   *
   * 커뮤니티 댓글을 신고합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityCommentControllerReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityCommentControllerReport$Response(params: CommunityCommentControllerReport$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityCommentDto>> {
    return communityCommentControllerReport(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 댓글 신고.
   *
   * 커뮤니티 댓글을 신고합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityCommentControllerReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityCommentControllerReport(params: CommunityCommentControllerReport$Params, context?: HttpContext): Observable<CommunityCommentDto> {
    return this.communityCommentControllerReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommunityCommentDto>): CommunityCommentDto => r.body)
    );
  }

  /** Path part for operation `communityCommentControllerToggleBlocked()` */
  static readonly CommunityCommentControllerToggleBlockedPath = '/api/community-comments/{id}/toggle-blocked';

  /**
   * 커뮤니티 댓글 차단 ON/OFF.
   *
   * 커뮤니티 댓글 차단 여부를 스위칭합니다. 차단 시, 댓글 및 해당 댓글의 대댓글은 게시글 데이터에 포함되지 않습니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityCommentControllerToggleBlocked()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerToggleBlocked$Response(params: CommunityCommentControllerToggleBlocked$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityCommentDto>> {
    return communityCommentControllerToggleBlocked(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 댓글 차단 ON/OFF.
   *
   * 커뮤니티 댓글 차단 여부를 스위칭합니다. 차단 시, 댓글 및 해당 댓글의 대댓글은 게시글 데이터에 포함되지 않습니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityCommentControllerToggleBlocked$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityCommentControllerToggleBlocked(params: CommunityCommentControllerToggleBlocked$Params, context?: HttpContext): Observable<CommunityCommentDto> {
    return this.communityCommentControllerToggleBlocked$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommunityCommentDto>): CommunityCommentDto => r.body)
    );
  }

}
